import { TaxiReservationApiTaxiReservationDeleteRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiReservationDeleteMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiReservationApiTaxiReservationDeleteRequest, config) =>
      appApiClient.taxiReservationApi.taxiReservationDelete(req, config),
  });
